module.exports = __webpack_public_path__ + "assets/notification.0dd56e88a41a52571e421b621e4d456b.svg";